export default function FlyMuse() {
    return (
        <div data-testid="fly-muse-page" className="pt-20 md:pt-24 pb-0">
            <div className="max-w-[1600px] mx-auto px-4 md:px-8 lg:px-12">
                <div className="flex items-end justify-between gap-4 mb-4 md:mb-6 pt-4">
                    <div>
                        <p className="font-mono-acc text-[10px] md:text-[11px] tracking-[0.32em] uppercase text-[var(--sienna)]">
                            § Flymuse × K-Team
                        </p>
                        <h1 className="mt-2 font-serif-display text-3xl md:text-5xl leading-none tracking-tight">
                            The Fly Muse
                        </h1>
                    </div>
                    <a
                        href="https://theflymuse.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="fly-muse-open-external"
                        className="font-mono-acc text-[10px] md:text-xs tracking-[0.32em] uppercase text-[var(--muted)] hover:text-[var(--sienna)] transition-colors whitespace-nowrap"
                    >
                        Open in new tab ↗
                    </a>
                </div>

                <div className="border border-[var(--ink)]/25 bg-[var(--bg-paper)] overflow-hidden">
                    <iframe
                        src="https://theflymuse.com"
                        title="The Fly Muse"
                        data-testid="fly-muse-iframe"
                        className="w-full block"
                        style={{ height: "calc(100vh - 220px)", minHeight: 600 }}
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation"
                    />
                </div>

                <p className="mt-4 mb-12 font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--muted)] text-center">
                    Embedded from theflymuse.com — the working world of Marvin
                    'The Fly' Kee
                </p>
            </div>
        </div>
    );
}
